"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FollowupOldList = void 0;
var _labelConsts = require("01_core/constants/labelConsts");
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _Table = _interopRequireDefault(require("@mui/material/Table"));
var _TableBody = _interopRequireDefault(require("@mui/material/TableBody"));
var _TableCell = _interopRequireDefault(require("@mui/material/TableCell"));
var _TableHead = _interopRequireDefault(require("@mui/material/TableHead"));
var _TableRow = _interopRequireDefault(require("@mui/material/TableRow"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _styles = require("@mui/material/styles");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 前年度フォローアップ（詳細画面）
 */
const StyledTableHead = (0, _styles.styled)(_TableHead.default)(_ref => {
  let {
    theme
  } = _ref;
  return {
    '& th': {
      background: theme.palette.table.header.primary.main,
      color: theme.palette.table.header.primary.contrastText
    }
  };
});
const StyledHeadLabel = (0, _styles.styled)(_Typography.default)(_ref2 => {
  let {
    theme
  } = _ref2;
  return {
    color: theme.palette.table.header.primary.contrastText,
    fontWeight: 'normal'
  };
});
const StyledTableRow = (0, _styles.styled)(_TableRow.default)(_ref3 => {
  let {
    theme
  } = _ref3;
  return {
    whiteSpace: 'pre-line',
    height: theme.spacing(5),
    '&:nth-of-type(even)': {
      background: theme.palette.table.body.secondary.main
    }
  };
});
const CellChapterTitle = (0, _styles.styled)(_TableCell.default)({
  width: '15%'
});
const CellHakkenjiko = (0, _styles.styled)(_TableCell.default)({
  width: '10%'
});
const FollowupOldList = props => {
  const {
    intl,
    followupList
  } = props;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Table.default, null, /*#__PURE__*/_react.default.createElement(StyledTableHead, null, /*#__PURE__*/_react.default.createElement(_TableRow.default, null, /*#__PURE__*/_react.default.createElement(CellChapterTitle, null, /*#__PURE__*/_react.default.createElement(StyledHeadLabel, null, intl.formatMessage({
    id: _labelConsts.LABEL.KANSA_SHITEKI_SHO_TITLE
  }))), /*#__PURE__*/_react.default.createElement(CellHakkenjiko, null, /*#__PURE__*/_react.default.createElement(StyledHeadLabel, null, intl.formatMessage({
    id: _labelConsts.LABEL.KANSA_RESULT_ZENNENDO_HAKKEN_JIKO_BUNRUI
  }))), /*#__PURE__*/_react.default.createElement(CellChapterTitle, null, /*#__PURE__*/_react.default.createElement(StyledHeadLabel, null, intl.formatMessage({
    id: _labelConsts.LABEL.KANSA_RESULT_ZENNENDO_HAKKEN_JIKO
  }))), /*#__PURE__*/_react.default.createElement(CellChapterTitle, null, /*#__PURE__*/_react.default.createElement(StyledHeadLabel, null, intl.formatMessage({
    id: _labelConsts.LABEL.KANSA_RESULT_HANDAN_KONKYO
  }))), /*#__PURE__*/_react.default.createElement(CellHakkenjiko, null, /*#__PURE__*/_react.default.createElement(StyledHeadLabel, null, intl.formatMessage({
    id: _labelConsts.LABEL.KANSA_RESULT_HANDAN_KEKKA
  }))), /*#__PURE__*/_react.default.createElement(CellHakkenjiko, null, /*#__PURE__*/_react.default.createElement(StyledHeadLabel, null, intl.formatMessage({
    id: _labelConsts.LABEL.KANSA_SHITEKI_HAKKEN_JIKO_BUNRUI
  }))), /*#__PURE__*/_react.default.createElement(CellChapterTitle, null, /*#__PURE__*/_react.default.createElement(StyledHeadLabel, null, intl.formatMessage({
    id: _labelConsts.LABEL.KANSA_SHITEKI_HAKKEN_JIKO
  }))), /*#__PURE__*/_react.default.createElement(CellChapterTitle, null, /*#__PURE__*/_react.default.createElement(StyledHeadLabel, null, intl.formatMessage({
    id: _labelConsts.LABEL.KANSA_RESULT_TAISAKUREI
  })))))), /*#__PURE__*/_react.default.createElement(_Table.default, null, /*#__PURE__*/_react.default.createElement(_TableBody.default, null, followupList && followupList.map((item, index) => {
    return /*#__PURE__*/_react.default.createElement(StyledTableRow, {
      key: index
    }, /*#__PURE__*/_react.default.createElement(CellChapterTitle, null, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "body2"
    }, item.chapterTitle.split('\n').map((line, i) => /*#__PURE__*/_react.default.createElement("span", {
      key: i
    }, line, /*#__PURE__*/_react.default.createElement("br", null))))), /*#__PURE__*/_react.default.createElement(CellHakkenjiko, null, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "body2"
    }, item.zenHakkenjikoBunruiNm)), /*#__PURE__*/_react.default.createElement(CellChapterTitle, null, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "body2"
    }, item.zenHakkenjiko)), /*#__PURE__*/_react.default.createElement(CellChapterTitle, null, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "body2"
    }, item.handanKonkyo)), /*#__PURE__*/_react.default.createElement(CellHakkenjiko, null, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "body2"
    }, item.handanKekkaNm)), /*#__PURE__*/_react.default.createElement(CellHakkenjiko, null, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "body2"
    }, item.hakkenjikoBunruiNm)), /*#__PURE__*/_react.default.createElement(CellChapterTitle, null, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "body2"
    }, item.hakkenjiko)), /*#__PURE__*/_react.default.createElement(CellChapterTitle, null, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "body2"
    }, item.taisakurei)));
  }))));
};
exports.FollowupOldList = FollowupOldList;
var _default = exports.default = (0, _reactIntl.injectIntl)(FollowupOldList);